<template>
    <div class="py-5">
        <div class="row">
            <div class="col-12">
                <p class="pb-3 mb-sm-2 text-center text-muted">Acepta pagos con SPEI por medio de openPay</p>
            </div>
            <div class="col-12">
                <a class="btn btn-info mb-5 py-2" data-toggle="collapse" href="#collapseSpeiBanks" role="button" aria-expanded="false" aria-controls="collapseExample">
                Bancos aceptados ↕
                </a>
            </div>
            <div class="collapse" id="collapseSpeiBanks">
                <div class="col-12">
                    <p class="mb-1 mb-sm-2 text-left">
                        Bancos con servicios SPEI
                    </p>
                    <div class="row mb-5 d-flex flex-wrap align-items-center justify-content-start">
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/abcCapital.jpg" alt="ABC Capital" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/afirme.png" alt="Afirme" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/bancoAzteca.png" alt="Banco Azteca" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/banbanjio.jpg" alt="Ban Banjio" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/citibanamex.png" alt="Citibanamex" class="img-fluid" width="100px" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/bancoBase.jpg" alt="Banco Base" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/bancoFamsa.jpeg" alt="Banco Famsa" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/bancoppel.jpg" alt="Bancoppel" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/banjercito.jpg" alt="Banjercito" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/banorte.png" alt="Banorte" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/banRegio.png" alt="BanRegio" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/bansi.jpg" alt="Bansi" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/bbva.png" alt="BBVA" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/ciBanco.jpg" alt="CIBanco" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/hsbc.jpeg" alt="HSBC" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/inbursa.png" alt="Inbursa" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/interacciones.jpeg" alt="Interacciones Grupo Financiero" class="img-fluid" width="100px" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/interBanco.jpeg" alt="InterBanco" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/invex.jpg" alt="Invex" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/ixe.jpeg" alt="Ixe" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/jpMorgan.jpg" alt="J.P Morgan" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/miBanco.jpeg" alt="Mi Banco" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/mifel.jpg" alt="Grupo Financiero Mifel" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/monex.png" alt="Grupo Financiero Monex" class="img-fluid" height="auto"></div>                  
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/santander.png" alt="Santander" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/scotiabank.png" alt="ScotiaBank" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/multiva.jpg" alt="Grupo Financiero Multiva" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/RBS.jpeg" alt="RBS" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/mufg.jpg" alt="MUFG" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/grupoFinanciero.jpg" alt="Grupo Financiero BX+" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/volkswagenBanck.jpg" alt="Volksgawen Banck" class="img-fluid" width="100px" height="auto"></div>
                    </div>
                </div>
            </div>
            <div class="col-12 p-0">
                <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between align-items-start">
                        <span class="mt-1 badge badge-success badge-pill">1</span>
                        <p class="pl-3 text-left w-100">Elige transferencia interbancaria (SPEI) como método de pago.</p>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-start">
                        <span class="mt-1 badge badge-success badge-pill">2</span>
                        <p class="pl-3 text-left w-100">Recibe el numero de referencia para hacer el pago a través de banca en línea.</p>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-start">
                        <span class="mt-1 badge badge-success badge-pill">3</span>
                        <p class="pl-3 text-left w-100">Inmediatamente después de recibir tu pago te enviaremos una notificacion de la confirmación de pago.</p>
                    </li>
                </ul>
            </div>
            <div class="w-100 text-end pt-2">
                Transacciones realizadas via: <img src="images/img_estilos/btnOpenPay.png" alt="paynet" class="img-responsive" width="100" height="auto"><br>
            </div>
        </div>
    </div>
</template>

<script>
const axios = require("axios");

    export default {
        name: "OpenPaySpei",
        props: ['api_url','products','addressData','receiver','codeCoupon'],
        data(){
            return{
                local_url: process.env.VUE_APP_SUSCRIPTIONS_LOCAL_ROUTE,
                itemPrice:null
            }
        },
        methods:{
            sendDataSpei: function(){
                // Consulta referencia de pago paynet
                axios({
                    method: "POST",
                    url: this.api_url + "/payment/bank",
                    data: {
                        user_id: $cookies.get("uidmmkg"),
                        items: this.products,
                        address: this.addressData,
                        address_id: this.addressData.id,
                        receiver: this.receiver,
                        code: this.codeCoupon
                    },
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + $cookies.get("utoken"),
                    },
                }).then((response) => {
                    if (response.data.status) {
                        console.log(response);
                        // Redireccionamiento a el pdf con la referencia generada
                        window.open(response.data.payment_url, "_blank");
                        // Redireccionamiento a la ficha de pago y agradecimiento

                        window.dataLayer.push({
                            'event': 'Pago',
                            'pageURL': this.$router.currentRoute.fullPath,
                            'product': this.products,
                            'months': "",
                            'address': this.addressData,
                            'paymentMethod': "Cargo de producto por referencia de pago SPEI, transferencias interbancarias",
                            'datePayment': new Date().toLocaleString('en-US')
                        });

                        this.$router.push({
                            name: "thanksForPay",
                            params: {
                                validate: true,
                                products: this.products
                            },
                        });
                        // Se vacia el carrito 
                        this.$store.commit('finishStore');
                    }
                    else{
                        // se actualiza el estado de el loader y el boton de el componente padre checkout.vue
                        this.$emit('updateStates', false, false);
                        this.$snotify.error("Sucedió un error en la transacción");
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$emit('updateStates', false, false);
                    this.$snotify.error(error);
                });
            }
        },
        created(){
            //   Escucha el tipo de pago a ejecutar paynet en este caso desde el checkout.vue
            this.$parent.$on('speiMethod', this.sendDataSpei);
        },
        mounted(){
            console.log('spei montado');
        }
    }
</script>

<style lang="scss" scoped>
img{
    image-rendering:-webkit-optimize-contrast; /* Safari         */
    image-rendering:optimize-contrast;         /* CSS3 Proposed  */
    -ms-interpolation-mode:nearest-neighbor;   /* IE8+           */
}
</style>